import * as React from 'react'
import styled from 'styled-components'
import {
  Card,
  CardContent,
  CardTitle,
  Select,
  Option,
  Textarea,
  Checkbox,
  Toast,
  ToastType
} from '../../../Components'
import { observer } from 'mobx-react'
import { PreProjetoModel, ProfessorModel, ValidationError } from '../../../Store'

interface IProps {
  onTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onSelectChange: (event: React.ChangeEvent<HTMLSelectElement>, idx: number) => any
  onCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>, field: string) => void
  aceitouTermosParaEnvio: boolean
  aceitouTermosParaAlterar: boolean
  naoEscolheuOsOrientadores: boolean
  orientadoresIguais: boolean
  disabled: boolean
  professores: ProfessorModel[]
  orientadores: ProfessorModel[]
  preProjeto: PreProjetoModel
  tema: string
  titulo: string
  justificativa: string
  desenvolvimento: string
  bibliografia: string
  errors: ValidationError<{
    tema: string,
    titulo: string,
    justificativa: string,
    desenvolvimento: string,
    bibliografia: string,
  }>
}

const FormularioContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12,1fr);
  grid-row-gap: 1rem;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`

const StyledTextarea = styled(Textarea) <any>`
  margin: 0;
  grid-column: ${p => p.gridColumn};
`

const StyledCheckbox = styled(Checkbox) <any>`
  margin-top: 30px;
`

const StyledSelect = styled(Select) <any>`
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 25px;
  grid-column: ${p => p.gridColumn};
`

const StyledText = styled.span`
  padding: 5px;
`;

@observer
export class FormPreProjetoCard extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  render() {
    const {
      onTextChange,
      onSelectChange,
      onCheckboxChange,
      aceitouTermosParaEnvio,
      aceitouTermosParaAlterar,
      naoEscolheuOsOrientadores,
      orientadoresIguais,
      disabled,
      professores,
      orientadores,
      errors,
      preProjeto,
      tema,
      titulo,
      justificativa,
      desenvolvimento,
      bibliografia,
    } = this.props;

    const Options =
      <>
        <Option value={0}> Selecione um orientador... </Option>
        {professores.map(p => (
          <Option value={p.id} key={p.id} disabled={orientadores!.includes(p) && true}>
            {p.nome}
          </Option>
        ))}
      </>

    return (
      <>
        <Card>
          <CardTitle>Informações do pré-projeto</CardTitle>
          <CardContent>
            <FormularioContainer>
              <StyledTextarea
                label='Tema (até 100 caracteres)'
                name='tema'
                onChange={onTextChange}
                maxLength={100}
                gridColumn='1/13'
                color={
                  errors && errors.tema != undefined ? 'errorColor'
                    : 'secondaryLightColor'}
                hasError={errors && errors.tema != undefined}
                errorMessage={errors && errors.tema}
                value={tema}
                disabled={disabled}
              />
              <StyledTextarea
                label='Título (até 150 caracteres)'
                name='titulo'
                onChange={onTextChange}
                maxLength={150}
                gridColumn='1/13'
                color={
                  errors && errors.titulo != undefined ? 'errorColor'
                    : 'secondaryLightColor'}
                hasError={errors && errors.titulo != undefined}
                errorMessage={errors && errors.titulo}
                value={titulo}
                disabled={disabled}
              />
              <StyledTextarea
                label='Justificativa - Descrição sucinta do problema (até 2000 caracteres)'
                name='justificativa'
                onChange={onTextChange}
                maxLength={2000}
                gridColumn='1/13'
                color={
                  errors && errors.justificativa != undefined ? 'errorColor'
                    : 'secondaryLightColor'}
                hasError={errors && errors.justificativa != undefined}
                errorMessage={errors && errors.justificativa}
                value={justificativa}
                disabled={disabled}
              />
              <StyledTextarea
                label='Desenvolvimento - Índice provisório ou hipótese de trabalho (até 1000 caracteres)'
                name='desenvolvimento'
                onChange={onTextChange}
                maxLength={1000}
                gridColumn='1/13'
                color={
                  errors && errors.desenvolvimento != undefined ? 'errorColor'
                    : 'secondaryLightColor'}
                hasError={errors && errors.desenvolvimento != undefined}
                errorMessage={errors && errors.desenvolvimento}
                value={desenvolvimento}
                disabled={disabled}
              />
              <StyledTextarea
                label='Bibliografia preliminar (até 1500 caracteres)'
                name='bibliografia'
                onChange={onTextChange}
                maxLength={1500}
                gridColumn='1/13'
                color={
                  errors && errors.bibliografia != undefined ? 'errorColor'
                    : 'secondaryLightColor'}
                hasError={errors && errors.bibliografia != undefined}
                errorMessage={errors && errors.bibliografia}
                value={bibliografia}
                disabled={disabled}
              />
            </FormularioContainer>
          </CardContent>
        </Card>
        <Card>
          <CardTitle>Escolha de orientador</CardTitle>
          {naoEscolheuOsOrientadores &&
            <Toast type={ToastType.error}>
              <StyledText>Obrigatório escolher três orientadores</StyledText>
            </Toast>
          }
          {orientadoresIguais &&
            <Toast type={ToastType.error}>
              <StyledText>Os orientadores devem ser diferentes</StyledText>
            </Toast>
          }
          <CardTitle>Indique suas preferências de orientador</CardTitle>
          <CardContent>
            <FormularioContainer>
              {orientadores.map((o, i) =>
                <StyledSelect
                  key={i}
                  name='orientadores'
                  label={`Opção ${i + 1}`}
                  value={(professores.find(p => p.nome === o.nome)
                    && professores.find(p => p.nome === o.nome)!.id) || 0}
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onSelectChange(e, i)}
                  gridColumn='1/13'
                  disabled={disabled}
                >
                  {Options}
                </StyledSelect>
              )}
            </FormularioContainer>
            {!preProjeto
              ?
              <StyledCheckbox
                label='Declaro estar ciente e de acordo com todas as disposições da regulamentação do TCC comentada, disponibilizada no classroom do TCC.'
                checked={aceitouTermosParaEnvio}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  onCheckboxChange(e, 'aceitouTermosParaEnvio')}
                disabled={disabled}
              />
              :
              <StyledCheckbox
                label='Declaro estar ciente das alterações realizadas por minha livre escolha, atinentes ao meu pré-projeto de TCC.'
                checked={aceitouTermosParaAlterar}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  onCheckboxChange(e, 'aceitouTermosParaAlterar')}
                disabled={disabled}
              />
            }
            <CardTitle>As informações atualizadas do seu Pré-projeto, permanecerão disponíveis para sua consulta via sistema.</CardTitle>
          </CardContent>
        </Card>
      </>
    );
  }
}